// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","313":"e1869865","513":"d1c460fc","706":"711ede07","726":"759a3e6d","871":"762c0f54"}[chunkId] + ".chunk.js";
};